/** @flow */
import * as actions from "@modules/reporting/constants/actions";
import * as tasksReducer from "./reducers";
import initialState from "./state";
import type { TasksState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: TasksState = initialState, action: Object): TasksState => {
  const act = {
    [actions.GetOutstandingTasks]: tasksReducer.setLoading,
    [actions.GetOutstandingTasksSuccess]: tasksReducer.onGetOutstandingTasksSuccess,
    [actions.GetOutstandingTasksError]: tasksReducer.setError,
    [actions.SubmitRTWInterviewTask]: tasksReducer.setLoading,
    [actions.SubmitRTWInterviewTaskSuccess]: tasksReducer.setLoaded,
    [actions.SubmitRTWInterviewTaskError]: tasksReducer.setError,
    [actions.SaveDraftRTWInterviewTask]: tasksReducer.setLoading,
    [actions.SaveDraftRTWInterviewTaskSuccess]: tasksReducer.setLoaded,
    [actions.SaveDraftRTWInterviewTaskError]: tasksReducer.setError,
    [actions.SaveDraftAbsenceTask]: tasksReducer.setLoading,
    [actions.SaveDraftAbsenceTaskSuccess]: tasksReducer.setLoaded,
    [actions.SaveDraftAbsenceTaskError]: tasksReducer.setError,
    [actions.GetAbsenceTask]: tasksReducer.setLoading,
    [actions.GetAbsenceTaskSuccess]: tasksReducer.onGetAbsenceTaskSuccess,
    [actions.GetManagerLedReferralTask]: tasksReducer.setLoading,
    [actions.GetManagerLedReferralTaskSuccess]: tasksReducer.onGetManagerLedReferralTaskSuccess,
    [actions.GetManagerLedReferralTaskError]: tasksReducer.setError,
    [actions.GetAbsenceTaskError]: tasksReducer.setError,
    [actions.GetAbsenceTaskSchema]: tasksReducer.setLoading,
    [actions.GetAbsenceTaskSchemaSuccess]: tasksReducer.onGetAbsenceTaskSchemaSuccess,
    [actions.GetAbsenceTaskSchemaError]: tasksReducer.setError,
    [actions.GetRtwInterviewTask]: tasksReducer.setLoading,
    [actions.GetRtwInterviewTaskSuccess]: tasksReducer.onGetRtwInterviewTaskSuccess,
    [actions.SetRtwInterviewTaskHistory]: tasksReducer.onSetRtwInterviewTaskHistory,
    [actions.GetRtwInterviewTaskError]: tasksReducer.setError,
    [actions.ToggleLateSubmissionModal]: tasksReducer.onToggleLateSubmissionModal,
    [actions.SetMyTasksSearch]: tasksReducer.onSetMyTasksSearch,
    [actions.SetMyTasksType]: tasksReducer.onSetMyTasksType,
    [actions.SubmitManagerLedReferralDraft]: tasksReducer.setLoading,
    [actions.SubmitManagerLedReferralDraftSuccess]: tasksReducer.setLoaded,
    [actions.SubmitManagerLedReferralDraftError]: tasksReducer.setError,
    [actions.UpdateManagerLedReferralDraft]: tasksReducer.setLoading,
    [actions.UpdateManagerLedReferralDraftSuccess]: tasksReducer.setLoaded,
    [actions.UpdateManagerLedReferralDraftError]: tasksReducer.setError,
    [actions.SubmitAbsenceTask]: tasksReducer.setLoading,
    [actions.SubmitAbsenceTaskSuccess]: tasksReducer.setLoaded,
    [actions.SubmitAbsenceTaskError]: tasksReducer.setError,
    [actions.GetTasksPerformance]: tasksReducer.setLoading,
    [actions.GetTasksPerformanceSuccess]: tasksReducer.onGetTasksPerformanceSuccess,
    [actions.GetTasksPerformanceError]: tasksReducer.setError,
    [actions.ExportOutstandingTasks]: tasksReducer.setLoading,
    [actions.ExportOutstandingTasksSuccess]: tasksReducer.setLoaded,
    [actions.ExportOutstandingTasksError]: tasksReducer.setError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
